import { Result, IUser, IEvent, IPost, IGroup } from '@/classes'
import { fetchAPI } from '@/utils/useAPI'
import { INotification, INotificationQueue } from '@/classes/Notification'
import { IOrganization } from '~/classes/Organization'

export const notificationReadAPI = async (params: {
	type: 'read' | 'delete' | 'delete-all'
	notifications?: string[]
}) => {
	const response: Result<{ notifications: INotification[] }> = await fetchAPI('user/notifications', params, { method: 'POST' })

	return response
}

export const notificationsGetAPI = async () => {
	const response: Result<{
		notificationQueue: INotificationQueue[]
		users: IUser[]
		events: IEvent[]
		posts: IPost[]
		groups: IGroup[]
		organizations: IOrganization[]
	}> = await fetchAPI('user/notifications/get', {}, { method: 'POST' })

	return response
}